import link from "@/scripts/host.js";

export default {
  name: "ResetPassword",
  data() {
    return {
      userName: "",
      code: "",
      newPassword: "",
      repeatPassword: "",
      invalid: false,
      errorMsg: ''
    };
  },
  methods: {
    checkPassword() {
      const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;
      return re.test(this.newPassword);
    },
    reset() {
      if (this.newPassword === this.repeatPassword) {
        if(this.checkPassword()){
          this.invalid = false;
        this.axios({
          method: "post",
          url: `${link.hostLink}Account/ResetPassword`,
          data: { userName: this.$route.params.name, password: this.newPassword, code:this.$route.query.token}
        })
          .then(() => {
            this.$router.push('/');
            this.$store.dispatch('setModalType', 'afterReset');
            this.$store.dispatch("toggleLoginModal");
          }

          )
          .catch((error) => {
            this.errorMsg = error.response.data.exception
          });
        } else {
          this.errorMsg = "Hasło musi mieć minimum 6 znaków, w tym min. 1 dużą literę i 1 cyfrę";
        }
      } else {
          this.errorMsg = "Hasło nie jest takie samo w obu przypadkach";
      }
    }
  },
  mounted() {}
};
